import Component from '../abstracts/Component';

export default class InfoBubbleComponent extends Component {
  get COMPONENTNAME() {
    return 'InfoBubbleComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      infoTrigger: this.$component,
    };
  }

  initInfoBubbleComponent() {
    const infoBubbleTrigger = this.dom.infoTrigger;
    let clickOnProgress = false;

    infoBubbleTrigger.classList.add('info-bubble-trigger');

    $(infoBubbleTrigger)
      .on('pointerdown', function (event) {
        if (event.target === this) {
          clickOnProgress = true;
          infoBubbleTrigger.classList.toggle('show');
        }
      })
      .on('pointerup', function () {
        clickOnProgress = false;
      })
      .on('mouseenter', function () {
        if (!clickOnProgress) {
          infoBubbleTrigger.classList.add('show');
        }
      })
      .on('mouseleave', function () {
        if (!clickOnProgress) {
          infoBubbleTrigger.classList.remove('show');
        }
      });
    $(document).on('pointerdown', function (event) {
      if (
        infoBubbleTrigger.classList.contains('show') &&
        !infoBubbleTrigger.contains(event.target)
      ) {
        infoBubbleTrigger.classList.remove('show');
      }
    });
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.initInfoBubbleComponent();
  }
}
